export default {
  common: {
    unexpectedError: 'Ein unerwarteter Fehler ist aufgetreten',
    unexpectedErrorWithDetails: 'Ein unerwarteter Fehler ist aufgetreten: {error}'
  },
  menu: {
    appName: 'Housebook User'
  },
  login: {
    title: 'Einloggen',
    email: 'E-Mail',
    password: 'Passwort',
    performLogin: 'Einloggen',
    resetPassword: 'Passwort vergessen?',
    invalidCredentialsError: 'Benutzername oder Passwort ungültig'
  },
  resetPassword: {
    title: 'Passwort zurücksetzen',
    email: 'E-Mail',
    description: 'Geben Sie die E-Mail-Adresse des Accounts ein, für den das Passwort zurückgesetzt werden soll.',
    performReset: 'Zurücksetzen',
    performLogin: 'Einloggen',
    successMsg: 'Sie erhalten in Kürze eine E-Mail an die eingegebene Adresse. Folgen Sie den Anweisungen in der E-Mail, um Ihr Passwort zurückzusetzen.'
  },
  edit: {
    title: 'Benutzerdaten bearbeiten',
    firstName: 'Vorname',
    lastName: 'Nachname',
    language: 'Sprache',
    phone: 'Telefon',
    country: 'Land',
    zip: 'PLZ',
    city: 'Stadt',
    street: 'Straße',
    streetNumber: 'Hausnummer',
    performSave: 'Speichern',
    succeeded: 'Benutzerdaten wurden geändert!'
  },
  blackboard: {
    title: 'Schwarzes Brett',
    performShow: 'Anzeigen'
  },
  onboarding: {
    signupTitle: 'Willkommen bei Housebook!',
    signupDescription: 'Sie wurden eingeladen, einen Housebook-Account zu erstellen. Bitte stimmen Sie den folgenden Bedingungen zu, um Ihre Anmeldung abzuschließen und Housebook zu benutzen.',
    invitationTitle: 'Housebook-Einladung',

    terms: 'Bitte lesen Sie die allgemeinen Geschäftsbedingungen von Housebook aufmerksam durch:',
    termsUrl: 'https://housebook-solutions.com/agb/',
    termsLink: 'Allgemeine Geschäftsbedingungen',
    acceptTermsOfService: 'Ich habe die allgemeinen Geschäftsbedingungen gelesen und stimme zu',

    invitation: 'Sie wurden eingeladen, dem Housebook-Unternehmen {organizationName} beizutreten.',
    acceptInvitation: 'Ich nehme die Einladung an',
    succeededTitle: 'Vorgang erfolgreich abgeschlossen!',
    nextSteps: 'Ihre nächsten Schritte mit Housebook:',
    editAccount: 'Bearbeiten Sie Ihre Account-Daten',
    editAccountButton: 'Account bearbeiten',
    installApp: 'Installieren Sie die Housebook-App auf Ihrem Smartphone',
    openHousebookControl: 'Verwalten Sie Projekt mit Housebook Control auf Ihrem Computer',
    openHousebookControlButton: 'Housebook Control öffnen',

    iosInstallTitle: 'Erhältlich im AppStore',
    androidInstallTitle: 'Jetzt bei Google Play',
    iosInstallBadgeUrl: 'https://linkmaker.itunes.apple.com/assets/shared/badges/de-de/appstore-lrg.svg',
    androidInstallBadgeUrl: 'https://play.google.com/intl/de_de/badges/images/generic/de_badge_web_generic.png',
    iosInstallUrl: 'https://itunes.apple.com/at/app/housebook-app/id1109844386?mt=8&at=10l6Xd&ct=ivtj5dzhg600xkod01g9a',
    androidInstallUrl: 'https://play.google.com/store/apps/details?id=at.bitstudios.housebook&utm_source=global_co&utm_medium=prtnr&utm_content=Mar2515&utm_campaign=PartBadge&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1&hl=de',

    credentials: 'Wählen Sie das Passwort für Ihren Housebook-Benutzernamen {username}.',
    username: 'Benutzername',
    password: 'Passwort',
    passwordRepeated: 'Passwort (wiederholen)',
    enterPasswordMsg: 'Geben Sie ein Passwort mit mindestens sieben Zeichen ein.',
    repeatPasswordMsg: 'Bitte wiederholen Sie das Passwort.',
    passwordsMatchMsg: 'Die Passwörter stimmen überein!',

    commit: 'Abschließen',

    invitationNotFoundError: 'Die Einladung wurde nicht gefunden',
    invitationExpiredError: 'Die Einladung ist abgelaufen',
    invitationAlreadyAcceptedError: 'Die Einladung wurde bereits angenommen',
    requiresLoginError: 'Sie müssen sich einloggen',
    invalidUserError: 'Sie sind nicht der eingeladene Benutzer'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/de.js